import { render, staticRenderFns } from "./SearchbaseGeneResultItem.vue?vue&type=template&id=3925cff0&scoped=true&"
import script from "./SearchbaseGeneResultItem.vue?vue&type=script&lang=js&"
export * from "./SearchbaseGeneResultItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchbaseGeneResultItem.vue?vue&type=style&index=0&id=3925cff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3925cff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
